import React from "react"
import { useTranslation } from "react-i18next"

import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"

import styles from "./index.module.css"

export const UsefullLinks: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Theme className={styles.Wrapper} theme="dark">
      <div className="container">
        <Heading as="h2" className={styles.Title} like="h1">
          <Raw html={t("investors-and-shareholders.UsefullLinks.Title")} />
        </Heading>
        {/* TODO: Переделать в отдельный общий компонент */}
        <div className={styles.Links}>
          {/*<div className={styles.LinkWrapper}>*/}
          {/*  <a*/}
          {/*    dangerouslySetInnerHTML={{*/}
          {/*      __html: t("investors-and-shareholders.UsefullLinks.Link.04"),*/}
          {/*    }}*/}
          {/*    href="/investors-and-shareholders/financial"*/}
          {/*  />*/}
          {/*</div>*/}

          {/*<div className={styles.LinkWrapper}>*/}
          {/*  <a*/}
          {/*    dangerouslySetInnerHTML={{*/}
          {/*      __html: t("investors-and-shareholders.UsefullLinks.Link.01"),*/}
          {/*    }}*/}
          {/*    href="/investors-and-shareholders/analytics"*/}
          {/*  />*/}
          {/*</div>*/}

          <div className={styles.LinkWrapper}>
            <a
              dangerouslySetInnerHTML={{
                __html: t("investors-and-shareholders.UsefullLinks.Link.02"),
              }}
              href="/investors-and-shareholders/faq"
            />
          </div>

          <div className={styles.LinkWrapper}>
            <a
              dangerouslySetInnerHTML={{
                __html: t("investors-and-shareholders.UsefullLinks.Link.03"),
              }}
              href="/investors-and-shareholders/disclosure"
            />
          </div>

          <div className={styles.LinkWrapper}>
            <a
              dangerouslySetInnerHTML={{
                __html: t("investors-and-shareholders.UsefullLinks.Link.05"),
              }}
              href="/upload/iblock/941/v4ik7l64pzp7is3s5hln77bni6eedk0e/Forma-_usloviya_-soglasheniya-o-konfidentsialnosti-dlya-aktsionerov.pdf"
            />
          </div>
        </div>
      </div>
    </Theme>
  )
}
